import { dispatchAlertForAPIV2Error } from '@/store/location_module/history'

export async function trycatchAPIErrors(fn, fallbackValue, dispatch) {
  //Check if fn is function type
  if (typeof fn !== 'function') {
    const error = 'Please provide a valid function'

    console.warn('ERR', error)
    return fallbackValue
  }

  try {
    return await fn()
  } catch (err) {
    console.warn('ERR', err)
    await dispatchAlertForAPIV2Error(err, dispatch)
    return fallbackValue
  }
}
